import type * as React from 'react';

import type * as api from '@gitbook/api-client';

import { CommentMessage } from './CommentMessage';
import { useListPaginatedCommentReplies } from './useListPaginatedCommentReplies';

export type CommentThreadProps = {
    /* The comment to display. */
    comment: api.Comment;
};

/**
 * Displays a comment message along with replies, when toggled to show.
 */
export function CommentThread(props: CommentThreadProps): React.ReactElement {
    const { comment } = props;

    const [commentReplies] = useListPaginatedCommentReplies({
        spaceId: comment.target.space,
        commentId: comment.id,
        changeRequestId: comment.target.changeRequest,
    });

    return (
        <div className="flex flex-col gap-2 pt-1">
            {commentReplies?.map((reply, index) => (
                <CommentMessage
                    key={reply.id}
                    comment={comment}
                    commentReply={reply}
                    isLastReply={index === commentReplies.length - 1}
                />
            ))}
        </div>
    );
}
